<template>
  <b-sidebar
    id="sidebar-aside"
    title="Herramientas"
    shadow
    right
    backdrop
    backdrop-variant="transparent"
    class="app-aside"
    header-class="app-aside__header"
    body-class="app-aside__body"
    @shown="$emit('shown')"
    @hidden="$emit('hidden')"
  >
    <b-tabs v-model="tabIndex" :key="'sidebar-' + tabIndex" class="app-aside-tabs">
      <b-tab content-class="app-aside-tab-shortcuts" @click="setTab('shortcuts')">
        <template slot="title">
          <AppIcon
            icon="star-fill"
            class="aside-tab-icon"
            font-scale="1.25"
            weight="500"
            v-b-tooltip.hover.bottom
            title="Favoritos"
          ></AppIcon>
        </template>

        <ShortcutsManager presentation="aside" :nav-items="navItems" sync-from-server />
      </b-tab>

      <b-tab v-if="!shortcutsOnly" @click="setTab('search')" >
        <template slot="title">
          <AppIcon
            icon="search"
            class="aside-tab-icon"
            font-scale="1.25"
            weight="500"
            v-b-tooltip.hover.bottom
            title="Busqueda avanzada del sistema"
          ></AppIcon>
        </template>

        <b-list-group class="aside-search-list">
          <b-list-group-item class="aside-search-container">
            <div class="aside-panel-heading">
              <AppIcon icon="search"></AppIcon>
              <div><strong>Buscar contactos</strong><small>Clientes, proveedores y staff</small></div>
            </div>
            <b-input-group>
              <b-form-input v-model="filter.name" 
                            size="sm"
                            placeholder="Ingresá al menos 3 caracteres"
                            v-on:keyup.enter.native="getFilterByName()" 
                            v-b-tooltip.hover.centerbottom title="Escriba su Búsqueda">
              </b-form-input>

              <b-input-group-append>
                <b-button variant="link"
                          class="aside-icon-btn aside-icon-btn--primary"
                          size="sm" 
                          @click="getFilterByName()" 
                          v-b-tooltip.hover.centerbottom 
                          title="Filtre su Búsqueda">
                  <AppIcon icon="funnel-fill"></AppIcon>
                </b-button>      
              </b-input-group-append>
            </b-input-group>
          </b-list-group-item>

          <div v-if="status && !items.customers.length && !items.staff.length && !items.suppliers.length" class="aside-empty-state">
            <AppIcon icon="search"></AppIcon>
            <strong>No se encontraron resultados</strong>
          </div>
          <div v-if="!status && !items.customers.length && !items.staff.length && !items.suppliers.length" class="aside-empty-state">
            <AppIcon icon="search"></AppIcon>
            <span>El filtro buscará entre clientes, proveedores y staff.</span>
          </div>

          <!-- STAFF -->
          <b-list-group-item v-if="canSearchStaff && items.staff.length" class="search-section-title">
            Staff
          </b-list-group-item>
          <div v-if="canSearchStaff && items.staff.length">
            <b-list-group-item class="access-direct-select aside-search-result"
                             v-for="value in items.staff" 
                             v-bind:key="value.id" 
                             @click="goStaff(value)">             
            
              
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(value.name).text"
                          :style="avatarFromName(value.name).style">
                </b-avatar>     
                <AppIcon icon="blank"></AppIcon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   
          
          <!-- CLIENTES -->
          <b-list-group-item v-if="canSearchCustomers && items.customers.length" class="search-section-title">
            Clientes
          </b-list-group-item>
          <div v-if="canSearchCustomers && items.customers.length">
            <b-list-group-item class="access-direct-select aside-search-result"
                             v-for="value in items.customers" 
                             v-bind:key="value.id" 
                             @click="goCustomers(value)">             
            
              
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(value.name).text"
                          :style="avatarFromName(value.name).style">
                </b-avatar>     
                <AppIcon icon="blank"></AppIcon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   

          <!-- PROVEEDORES -->
          <b-list-group-item v-if="canSearchSuppliers && items.suppliers.length" class="search-section-title">
            Proveedores
          </b-list-group-item>
          <div v-if="canSearchSuppliers && items.suppliers.length">
            <b-list-group-item class="access-direct-select aside-search-result"
                             v-for="value in items.suppliers" 
                             v-bind:key="value.id" 
                             @click="goSuppliers(value)">             
                          
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else
                          :text="avatarFromName(value.name).text"
                          :style="avatarFromName(value.name).style">
                </b-avatar>     
                <AppIcon icon="blank"></AppIcon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   

        </b-list-group>

      </b-tab>
      
      <b-tab v-if="!shortcutsOnly" @click="setTab('printer'); filterReport();">
        <template slot="title">
          <AppIcon
            icon="printer"
            class="aside-tab-icon"
            font-scale="1.25"
            weight="500"
            v-b-tooltip.hover.bottom
            title="Últimas impresiones"
          ></AppIcon>
        </template>

        <div class="aside-panel-toolbar">
          <div><strong>Últimas impresiones</strong><small>Reimprimí documentos recientes.</small></div>
        <b-button variant="link"
                  size="sm" 
                  class="aside-icon-btn"
                  @click="filterReport()" 
                  v-b-tooltip.hover.centerbottom 
                  title="Actualizar datos">
          <AppIcon icon="arrow-repeat"></AppIcon>
        </b-button>
        </div>

        <div class="text-center mt-5" v-if="reports.load"> 
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div v-else>
          <b-list-group v-if="reports.data.length" class="aside-print-list">
            <b-list-group-item v-for="element in reports.data" :key="element.id"
                              href="javascript:void(0);"                              
                              class="flex-column align-items-start aside-print-item"
                              @click="sendPrinter(element)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{element.title}}</h5>
                <small>{{moment.duration(-moment().diff(element.date)).humanize(true)}}</small>
              </div>
              
              <div v-if="element.metadata">                    
                <b-badge v-for="(item, index) in element.metadata.split('|')" 
                          :key="index" href="javascript:void(0);" 
                          variant="light"
                          class="ml-1"
                          style="font-size:12px;">
                  {{item}}
                </b-badge>
              </div>              
            </b-list-group-item>        
          </b-list-group>        
          <div v-else class="aside-empty-state"><AppIcon icon="printer"></AppIcon><span>No se encontraron impresiones</span></div>
        </div>
      </b-tab>

      <b-tab v-if="!shortcutsOnly && canViewScheduledTasksInfo" @click="setTab('scheduledTasks')">
        <template slot="title">
          <AppIcon
            icon="clock-history"
            class="aside-tab-icon"
            font-scale="1.25"
            weight="500"
            v-b-tooltip.hover.bottom
            title="Tareas programadas y jobs"
          ></AppIcon>
        </template>

        <div class="aside-panel-toolbar">
          <div><strong>Estado del sistema</strong><small>Tareas programadas y jobs.</small></div>
        <b-button variant="link"
                  size="sm"
                  class="aside-icon-btn"
                  @click="loadScheduledTasksMonitor(true)"
                  v-b-tooltip.hover.centerbottom
                  title="Actualizar datos">
          <AppIcon icon="arrow-repeat"></AppIcon>
        </b-button>
        </div>

        <div class="text-center mt-5" v-if="scheduledTasks.load">
          <b-spinner label="Spinning"></b-spinner>
        </div>

        <div v-else-if="scheduledTasks.loaded" class="p-2">
          <b-alert show variant="light" class="small text-center mb-2">
            Datos generados: {{formatScheduledTaskDateWithSeconds(scheduledTasks.data.generated_at)}}
          </b-alert>

          <div class="scheduled-accordion" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-warning" role="tab">
                <b-button block v-b-toggle="'scheduled-in-progress'" variant="light" class="text-left">
                  En curso
                  <b-badge variant="warning" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.started_without_finish_total}} cron / {{scheduledTasks.data.jobs.pending_total}} jobs
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-in-progress" visible accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div class="scheduled-subsection-title">
                    Cron iniciados sin finalizar
                  </div>
                  <div v-if="scheduledTasks.data.scheduled_tasks.started_without_finish_previous_total"
                       class="scheduled-warning-summary mb-2">
                    <div class="scheduled-warning-summary-count">
                      {{scheduledTasks.data.scheduled_tasks.started_without_finish_previous_total}}
                    </div>
                    <div>
                      <div class="font-weight-bold">Inicio(s) sin finalizar de días anteriores</div>
                      <small>Revisar porque ya no corresponde tratarlos como procesos en curso normales.</small>
                    </div>
                  </div>
                  <b-list-group v-if="scheduledTasks.data.scheduled_tasks.started_without_finish_today.length">
                    <b-list-group-item v-for="(element, index) in scheduledTasks.data.scheduled_tasks.started_without_finish_today"
                                      :key="'started-without-finish-' + index"
                                      class="flex-column align-items-start">
                      <div class="d-flex w-100 justify-content-between">
                        <b>{{element.task || 'Sin tarea'}}</b>
                        <b-badge variant="warning">{{element.total}} inicio(s)</b-badge>
                      </div>
                      <div class="small text-muted">
                        {{element.module || 'Sin módulo'}} · Último inicio: {{formatScheduledTaskDate(element.last_date)}}
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay tareas en curso sin finalizar hoy
                  </b-alert>

                  <div class="scheduled-subsection-title mt-3">
                    Jobs en cola
                  </div>
                  <b-list-group v-if="scheduledTasks.data.jobs.pending_groups.length">
                    <b-list-group-item v-for="(element, index) in scheduledTasks.data.jobs.pending_groups"
                                      :key="'pending-job-' + index"
                                      class="flex-column align-items-start">
                      <div class="scheduled-task-item">
                        <div class="scheduled-task-title">{{element.job || 'Job no identificado'}}</div>
                        <div class="scheduled-task-meta"
                             v-b-tooltip.hover
                             :title="formatScheduledTaskDate(element.oldest_created_at)">
                          Cola: {{element.queue}} · Más viejo: {{formatScheduledTaskDateHuman(element.oldest_created_at)}}
                        </div>
                        <div class="scheduled-task-meta"
                             v-if="element.last_reserved_at"
                             v-b-tooltip.hover
                             :title="formatScheduledTaskDate(element.last_reserved_at)">
                          Último tomado por worker: {{formatScheduledTaskDateHuman(element.last_reserved_at)}}
                        </div>
                        <div class="scheduled-task-stats scheduled-task-stats-info">
                          <span>{{element.available_total}} disponibles</span>
                          <span>{{element.reserved_total}} tomados</span>
                          <span>{{element.total}} total</span>
                        </div>
                        <div class="scheduled-job-attempts" v-if="element.max_attempts > 0">
                          Máximo de intentos registrados: {{element.max_attempts}}
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay jobs pendientes en cola
                  </b-alert>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-info" role="tab">
                <b-button block v-b-toggle="'scheduled-upcoming'" variant="light" class="text-left">
                  Próximas 24 hs
                  <b-badge variant="info" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.upcoming.length}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-upcoming" accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div v-if="scheduledUpcomingRecurring.length" class="mb-2">
                    <div class="scheduled-subsection-title">
                      Alta frecuencia
                    </div>
                    <b-list-group flush>
                      <b-list-group-item v-for="(element, index) in scheduledUpcomingRecurring"
                                        :key="'upcoming-recurring-' + index"
                                        class="flex-column align-items-start scheduled-upcoming-item">
                        <div class="d-flex w-100 justify-content-between align-items-start">
                          <b class="scheduled-task-title scheduled-upcoming-title">{{element.name || 'Sin tarea'}}</b>
                          <b-badge variant="info">{{frequencyLabel(element)}}</b-badge>
                        </div>
                        <div class="scheduled-task-meta">
                          {{element.source}} · {{element.expression}}
                        </div>
                        <div class="scheduled-task-meta mb-0">
                          Próxima: {{formatScheduledTaskDate(element.date)}} · {{element.runs_in_day}} ejecuciones en 24 hs
                        </div>
                      </b-list-group-item>
                    </b-list-group>
                  </div>

                  <div v-if="scheduledUpcomingGroups.length">
                    <b-card v-for="(group, groupIndex) in scheduledUpcomingGroups"
                            :key="'upcoming-hour-group-' + groupIndex"
                            no-body
                            class="mb-2 scheduled-upcoming-group">
                      <b-card-header class="scheduled-upcoming-group-header py-2" header-tag="header" role="tab">
                        <b-button block
                                  v-b-toggle="'scheduled-upcoming-hour-' + groupIndex"
                                  variant="light"
                                  class="scheduled-upcoming-button text-left">
                          <div>
                            <div class="font-weight-bold">{{group.label}}</div>
                            <small class="text-muted">{{group.items.length}} ejecución(es)</small>
                          </div>
                          <b-badge variant="info">{{group.hour}}</b-badge>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'scheduled-upcoming-hour-' + groupIndex"
                                  accordion="scheduled-upcoming-hours"
                                  role="tabpanel">
                        <b-list-group flush>
                          <b-list-group-item v-for="(element, index) in group.items"
                                            :key="'upcoming-task-' + groupIndex + '-' + index"
                                            class="flex-column align-items-start scheduled-upcoming-item">
                            <div class="d-flex w-100 justify-content-between align-items-start">
                              <b class="scheduled-task-title scheduled-upcoming-title">{{element.name || 'Sin tarea'}}</b>
                              <small class="text-info font-weight-bold scheduled-upcoming-time">{{formatScheduledTaskDate(element.date)}}</small>
                            </div>
                            <div class="scheduled-task-meta">
                              {{element.source}} · {{element.expression}}
                            </div>
                            <div class="scheduled-task-meta mb-0">
                              Próxima ejecución agrupada en esta hora
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-if="!scheduledUpcomingRecurring.length && !scheduledUpcomingGroups.length" show variant="warning" class="text-center">
                    No se detectaron próximas ejecuciones
                  </b-alert>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-danger" role="tab">
                <b-button block v-b-toggle="'scheduled-failed'" variant="light" class="text-left">
                  Fallidas
                  <b-badge variant="danger" class="float-right">
                    {{scheduledTasks.data.failed_jobs.total + scheduledTasks.data.scheduled_tasks.errors.total + (isModuleVentasActive ? scheduledTasks.data.sales_sync_errors.unique_total : 0) + (isModulePedidosActive ? scheduledTasks.data.orders_sync_errors.unique_total : 0)}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-failed" accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div class="scheduled-subsection-title">
                    Cron con error
                  </div>
                  <div v-if="scheduledTasks.data.scheduled_tasks.errors.groups.length">
                    <b-card v-for="(element, index) in scheduledTasks.data.scheduled_tasks.errors.groups"
                            :key="'scheduled-error-group-' + index"
                            no-body
                            class="mb-2 scheduled-error-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-error-header" role="tab">
                        <b-button block
                                  v-b-toggle="'scheduled-error-group-' + index"
                                  variant="light"
                                  class="text-left scheduled-error-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{element.task || 'Sin tarea'}}</span>
                            <AppIcon icon="chevron-down" class="scheduled-accordion-icon"></AppIcon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{element.today_total}} hoy / {{element.total}} total
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'scheduled-error-group-' + index"
                                  accordion="scheduled-error-groups"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-item">
                            <div class="scheduled-task-title"
                                 v-if="element.task">
                              {{element.task}}
                            </div>
                            <div class="scheduled-task-meta">
                              {{element.category}} · {{element.module || 'Sin módulo'}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-if="element.observations">
                              {{element.observations}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_date)">
                              Última aparición: {{formatScheduledTaskDateHuman(element.last_date)}}
                            </div>
                            <div class="scheduled-task-stats scheduled-task-stats-danger">
                              <span>{{element.today_total}} hoy</span>
                              <span>{{element.total}} total</span>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de cron registrados
                  </b-alert>
                  <div class="scheduled-maintenance-actions"
                       v-if="scheduledTasks.data.scheduled_tasks.errors.total">
                    <b-button v-if="scheduledTasks.data.scheduled_tasks.errors.old_total"
                              size="sm"
                              variant="outline-secondary"
                              @click="confirmCleanupScheduledTasks('Error', 'older_than_year')">
                      Limpiar fallidas anteriores a 365 días
                    </b-button>
                    <b-button v-else
                              size="sm"
                              variant="outline-danger"
                              @click="confirmCleanupScheduledTasks('Error', 'all')">
                      Borrar todas las fallidas
                    </b-button>
                  </div>

                  <div class="scheduled-subsection-title mt-3">
                    Jobs fallidos
                  </div>
                  <div v-if="scheduledTasks.data.failed_jobs.groups.length">
                    <b-card v-for="(element, index) in scheduledTasks.data.failed_jobs.groups"
                            :key="'failed-group-' + index"
                            no-body
                            class="mb-2 scheduled-error-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-error-header" role="tab">
                        <b-button block
                                  v-b-toggle="'failed-job-group-' + index"
                                  variant="light"
                                  class="text-left scheduled-error-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">
                              <span class="scheduled-accordion-title">{{getFailedJobTitle(element)}}</span>
                            </span>
                            <AppIcon icon="chevron-down" class="scheduled-accordion-icon"></AppIcon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{element.today_total}} hoy / {{element.total}} total
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'failed-job-group-' + index"
                                  accordion="failed-job-groups"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-item">
                            <div class="scheduled-task-title">
                              {{element.error_message || 'Job fallido'}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_failed_at)">
                              {{element.category}} · Cola: {{element.queue}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_failed_at)">
                              Última aparición: {{formatScheduledTaskDateHuman(element.last_failed_at)}}
                            </div>
                            <div class="scheduled-task-stats scheduled-task-stats-danger">
                              <span>{{element.today_total}} hoy</span>
                              <span>{{element.total}} total</span>
                            </div>
                            <div class="scheduled-group-actions">
                              <b-button size="sm"
                                        variant="outline-secondary"
                                        @click="confirmCleanupFailedJobs(element)">
                                Dejar solo última semana
                              </b-button>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de jobs registrados
                  </b-alert>

                  <template v-if="isModuleVentasActive">
                  <div class="scheduled-subsection-title mt-3">
                    Errores de facturación
                  </div>
                  <div v-if="scheduledTasks.data.sales_sync_errors.groups.length">
                    <b-card v-for="(staffGroup, staffIndex) in scheduledTasks.data.sales_sync_errors.groups"
                            :key="'sales-sync-error-staff-' + staffIndex"
                            no-body
                            class="mb-2 scheduled-sales-sync-staff-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-sales-sync-staff-header" role="tab">
                        <b-button block
                                  v-b-toggle="'sales-sync-error-staff-' + staffIndex"
                                  variant="light"
                                  class="text-left scheduled-sales-sync-staff-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{staffGroup.staff_name || 'Sin usuario'}}</span>
                            <AppIcon icon="chevron-down" class="scheduled-accordion-icon"></AppIcon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{staffGroup.unique_total}} comprobante(s)
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'sales-sync-error-staff-' + staffIndex"
                                  accordion="sales-sync-error-staff"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-meta"
                               v-b-tooltip.hover
                               :title="formatScheduledTaskDate(staffGroup.last_occurred_at)">
                            Última aparición: {{formatScheduledTaskDateHuman(staffGroup.last_occurred_at)}}
                          </div>
                          <b-list-group>
                            <b-list-group-item v-for="(element, errorIndex) in staffGroup.errors"
                                              :key="'sales-sync-error-' + staffIndex + '-' + errorIndex"
                                              class="flex-column align-items-start scheduled-sales-sync-error-item">
                              <div class="scheduled-task-item">
                                <div class="scheduled-task-title">{{element.error_message || 'Error sin detalle'}}</div>
                                <div class="scheduled-task-meta">
                                  {{element.category}} · Último intento: {{element.max_attempt || 0}}
                                </div>
                                <div class="scheduled-task-meta"
                                     v-b-tooltip.hover
                                     :title="formatScheduledTaskDate(element.last_occurred_at)">
                                  Última aparición: {{formatScheduledTaskDateHuman(element.last_occurred_at)}}
                                </div>
                                <div class="scheduled-task-stats scheduled-task-stats-danger">
                                  <span>{{element.today_unique_total}} hoy</span>
                                  <span>{{element.unique_total}} comp.</span>
                                </div>
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de facturación registrados
                  </b-alert>
                  </template>

                  <template v-if="isModulePedidosActive">
                  <div class="scheduled-subsection-title mt-3">
                    Errores de pedidos móviles
                  </div>
                  <div v-if="scheduledTasks.data.orders_sync_errors.groups.length">
                    <b-card v-for="(sellerGroup, sellerIndex) in scheduledTasks.data.orders_sync_errors.groups"
                            :key="'orders-sync-error-seller-' + sellerIndex"
                            no-body
                            class="mb-2 scheduled-sales-sync-staff-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-sales-sync-staff-header" role="tab">
                        <b-button block
                                  v-b-toggle="'orders-sync-error-seller-' + sellerIndex"
                                  variant="light"
                                  class="text-left scheduled-sales-sync-staff-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{sellerGroup.seller_name || 'Sin vendedor'}}</span>
                            <AppIcon icon="chevron-down" class="scheduled-accordion-icon"></AppIcon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{sellerGroup.unique_total}} pedido(s)
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'orders-sync-error-seller-' + sellerIndex"
                                  accordion="orders-sync-error-seller"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-meta"
                               v-b-tooltip.hover
                               :title="formatScheduledTaskDate(sellerGroup.last_occurred_at)">
                            Última aparición: {{formatScheduledTaskDateHuman(sellerGroup.last_occurred_at)}}
                          </div>
                          <b-list-group>
                            <b-list-group-item v-for="(element, errorIndex) in sellerGroup.errors"
                                              :key="'orders-sync-error-' + sellerIndex + '-' + errorIndex"
                                              class="flex-column align-items-start scheduled-sales-sync-error-item">
                              <div class="scheduled-task-item">
                                <div class="scheduled-task-title">{{element.error_message || 'Error sin detalle'}}</div>
                                <div class="scheduled-task-meta">
                                  {{element.category}} · Último intento: {{element.max_attempt || 0}}
                                </div>
                                <div class="scheduled-task-meta"
                                     v-b-tooltip.hover
                                     :title="formatScheduledTaskDate(element.last_occurred_at)">
                                  Última aparición: {{formatScheduledTaskDateHuman(element.last_occurred_at)}}
                                </div>
                                <div class="scheduled-task-stats scheduled-task-stats-danger">
                                  <span>{{element.today_unique_total}} hoy</span>
                                  <span>{{element.unique_total}} pedido(s)</span>
                                </div>
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de pedidos móviles registrados
                  </b-alert>
                  </template>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-success" role="tab">
                <b-button block v-b-toggle="'scheduled-executed'" variant="light" class="text-left">
                  Ejecutadas
                  <b-badge variant="success" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.executed_groups_by_module.length}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-executed" visible accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div v-if="scheduledTasks.data.scheduled_tasks.executed_groups_by_module.length">
                    <div v-for="(moduleGroup, moduleIndex) in scheduledTasks.data.scheduled_tasks.executed_groups_by_module"
                         :key="'executed-module-' + moduleIndex"
                         class="scheduled-module-group">
                      <b-card no-body>
                        <b-card-header header-tag="header" class="p-1 scheduled-module-header" role="tab">
                          <b-button block
                                    v-b-toggle="'scheduled-executed-module-' + moduleIndex"
                                    variant="light"
                                    class="text-left scheduled-module-button">
                            <span>{{moduleGroup.module}}</span>
                            <b-badge variant="success" class="float-right">{{moduleGroup.today_total}} hoy / {{moduleGroup.total}} total</b-badge>
                          </b-button>
                        </b-card-header>
                        <b-collapse :id="'scheduled-executed-module-' + moduleIndex"
                                    accordion="scheduled-executed-modules"
                                    role="tabpanel">
                          <b-card-body class="p-2">
                            <b-list-group>
                              <b-list-group-item v-for="(element, index) in moduleGroup.tasks"
                                                :key="'executed-group-' + moduleIndex + '-' + index"
                                                class="flex-column align-items-start scheduled-executed-item">
                                <div class="scheduled-task-item">
                                  <div class="scheduled-task-title">{{element.task || 'Sin tarea'}}</div>
                                  <div class="scheduled-task-meta"
                                       v-b-tooltip.hover
                                       :title="formatScheduledTaskDate(element.last_date)">
                                    Última: {{formatScheduledTaskDateHuman(element.last_date)}}
                                  </div>
                                  <div class="scheduled-task-stats scheduled-task-stats-success">
                                    <span>{{element.today_total}} hoy</span>
                                    <span>{{element.total}} total</span>
                                  </div>
                                </div>
                              </b-list-group-item>
                            </b-list-group>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay tareas ejecutadas registradas
                  </b-alert>
                  <div class="scheduled-maintenance-actions"
                       v-if="scheduledTasks.data.scheduled_tasks.executed_total">
                    <b-button v-if="scheduledTasks.data.scheduled_tasks.executed_old_total"
                              size="sm"
                              variant="outline-secondary"
                              @click="confirmCleanupScheduledTasks('Fin', 'older_than_year')">
                      Limpiar ejecutadas anteriores a 365 días
                    </b-button>
                    <b-button v-else-if="scheduledTasks.data.scheduled_tasks.executed_total"
                              size="sm"
                              variant="outline-danger"
                              @click="confirmCleanupScheduledTasks('Fin', 'all')">
                      Borrar todas las ejecutadas
                    </b-button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <b-alert v-else show variant="info" class="m-3 text-center">
          Ingrese a esta solapa para consultar el estado de tareas y jobs.
        </b-alert>
      </b-tab>

    </b-tabs>

    <!--
    ###########################
    ######### PRINTER #########
    ###########################
    -->
    <Printer v-if="crud.print.pdf" 
            :pdf="crud.print.pdf"               
            :key="crud.print.key"/>

  </b-sidebar>
</template>

<script>

import Error from '@/handler/error'
import Helper from '@/handler/helper' 
import serviceAPI from './services'
import Printer from '@/components/inc/printer/printer'
import Storage from '@/handler/storageLocal'
import Session from '@/handler/session'
import Modules from '@/config/modules'
import Profiles from '@/config/profiles'
import ShortcutsManager from './ShortcutsManager'
import Funciones from '@/handler/funciones'

export default {
  name: 'DefaultAside', 
  components: {
    Printer,
    ShortcutsManager,
  },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    shortcutsOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      filter: {
        name: ''
      },
      items: {
        customers: [],
        staff: [],
        suppliers: []
      },
      status: false,
      reports: {
        data: [],
        load: false,
      },
      scheduledTasks: {
        data: {
          generated_at: '',
          jobs: {
            pending_total: 0,
            pending_by_queue: [],
            pending_groups: [],
          },
          failed_jobs: {
            total: 0,
            today: 0,
            groups: [],
            recent: [],
          },
          sales_sync_errors: {
            total: 0,
            today: 0,
            unique_total: 0,
            unique_today: 0,
            groups: [],
          },
          orders_sync_errors: {
            total: 0,
            today: 0,
            unique_total: 0,
            unique_today: 0,
            groups: [],
          },
          scheduled_tasks: {
            total: 0,
            started_without_finish_total: 0,
            summary: [],
            completed_today: [],
            started_without_finish_today: [],
            started_without_finish_previous_total: 0,
            executed_total: 0,
            executed_old_total: 0,
            executed_groups: [],
            executed_groups_by_module: [],
            errors: {
              total: 0,
              today: 0,
              old_total: 0,
              groups: [],
            },
            upcoming: [],
            recent: [],
          },
        },
        load: false,
        loaded: false,
      },
      crud: {
        print: {
          pdf: '',            
          key: 0,
        }  
      },
      tabIndex: 0,
      modulesActive: [],
    }
  },
  mounted() {
    this.restoreTabStorage()
    this.modulesActive = Session.getSession().auth.user.permissions.modules
  },
  computed: {
    // Cada directorio del buscador se habilita por su propia vista CRUD. Así
    // un empleado puede buscar solo los tipos de contacto que tiene permiso
    // de abrir, sin depender de permisos ajenos como administración de
    // proyectos.
    canSearchStaff() {
      return this.hasSearchViewAccess(Modules.PERSONAL)
    },
    canSearchCustomers() {
      return this.hasSearchViewAccess(Modules.CLIENTES)
    },
    canSearchSuppliers() {
      return this.hasSearchViewAccess(Modules.PROVEEDORES)
    },
    // Los errores de facturación/pedidos móviles solo tienen sentido si el
    // módulo correspondiente (Ventas/Pedidos) está activado para la cuenta —
    // sin esto, un cliente sin ese módulo veía igual la sección (siempre en
    // "sin errores", pero visible y ocupando lugar).
    isModuleVentasActive() {
      return this.modulesActive.some(element => element.id == Modules.VENTAS)
    },
    isModulePedidosActive() {
      return this.modulesActive.some(element => element.id == Modules.PEDIDOS)
    },
    canViewScheduledTasksInfo() {
      let session = Session.getSession()
      if(!session || !session.auth || !session.auth.user) {
        return false
      }

      let currentStaff = session.auth.user.current_staff

      return !!(currentStaff && currentStaff.view_scheduled_tasks_info)
    },
    // Las tareas de alta frecuencia (cada minuto, cada 30 min, etc.) vienen
    // resumidas en una sola entrada con recurring=true — se muestran aparte
    // para que no tapen a las de baja frecuencia en los grupos por hora.
    scheduledUpcomingRecurring() {
      return this.scheduledTasks.data.scheduled_tasks.upcoming.filter(item => item.recurring)
    },
    scheduledUpcomingGroups() {
      return this.groupScheduledTasksByHour(this.scheduledTasks.data.scheduled_tasks.upcoming.filter(item => !item.recurring))
    },
  },
  methods: {
    avatarFromName(name) {
      return Funciones.avatarFromName(name)
    },
    hasSearchViewAccess(moduleId) {
      return Helper.showAccessView({
        module_id: moduleId,
        profile_id: Profiles.PERSONAL,
        view_reference: 'crud',
      }, 'crud')
    },
    setTab(reference) {      
      switch (reference) {
        case 'shortcuts':
          this.tabIndex = 0
          break;
        case 'search':
          this.tabIndex = 1
          break;
        case 'printer':
          this.tabIndex = 2
          break;
        case 'scheduledTasks':
          this.tabIndex = 3
          this.loadScheduledTasksMonitor()
          break;
      }      
      this.saveTabStorage()
    },

    getFilterByName() {
      if (this.filter.name.length < 3) {
        this.$awn.alert("Ingrese al menos 3 caracteres para realizar el filtro");      
        return false
      }

      this.items.customers = []
      this.items.staff = []
      this.items.suppliers = []
      this.status = true

      if (this.canSearchCustomers) this.getCustomersByName()
      if (this.canSearchStaff) this.getStaffByName()
      if (this.canSearchSuppliers) this.getSuppliersByName()
    },        

    getCustomersByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterCustomersByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.customers = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },
    getStaffByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterStaffByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.staff = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },
    getSuppliersByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterSuppliersByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.suppliers = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },

    goCustomers(item) {
      this.$router.push({ name: 'CustomerViewStaff', params: {customersID: item.id} })
    },        
    goStaff(item) {
      this.$router.push({ name: 'StaffViewStaff', params: {staffID: item.id} })
    },        
    goSuppliers(item) {
      this.$router.push({ name: 'SuppliersViewStaff', params: {suppliersID: item.id} })
    },

    filterReport() {      
      this.reports.load = true
      var result = serviceAPI.getFilterReportLog({
        staff: { code: Helper.getStaffId() }
      }, 1)

      result.then((response) => {
        this.reports.load = false
        this.reports.data = response.data.data        
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.reports.load = false
      });      
    },
    sendPrinter(item) {
      this.crud.print.key = Math.random()
      this.crud.print.pdf = item.url
    },    
    loadScheduledTasksMonitor(force) {
      if(this.scheduledTasks.loaded && !force) {
        return
      }

      this.scheduledTasks.load = true
      var result = serviceAPI.getScheduledTasksMonitor()

      result.then((response) => {
        // Backend anterior sin el monitor de pedidos móviles: default vacío
        // para que el template no falle.
        if (!response.data.orders_sync_errors) {
          response.data.orders_sync_errors = { total: 0, today: 0, unique_total: 0, unique_today: 0, groups: [] }
        }
        this.scheduledTasks.data = response.data
        this.scheduledTasks.loaded = true
        this.scheduledTasks.load = false
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    confirmCleanupScheduledTasks(status, mode) {
      let isExecuted = status == 'Fin'
      let typeText = isExecuted ? 'ejecutadas' : 'fallidas'
      let actionText = mode == 'all'
        ? 'Se eliminarán todas las tareas programadas ' + typeText + '.'
        : 'Se eliminarán solo tareas programadas ' + typeText + ' anteriores a 365 días.'

      this.$bvModal.msgBoxConfirm(actionText + ' No se eliminan jobs, errores de jobs ni logs de instancias. ¿Continuar?', {
        title: 'Limpiar historial de tareas programadas',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Limpiar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value) {
          this.cleanupScheduledTasks(status, mode)
        }
      })
    },
    cleanupScheduledTasks(status, mode) {
      this.scheduledTasks.load = true
      var result = serviceAPI.cleanupScheduledTasksMonitor({
        status: status,
        mode: mode
      })

      result.then((response) => {
        this.$awn.success('Historial limpiado. Registros eliminados: ' + response.data.deleted)
        this.scheduledTasks.loaded = false
        this.loadScheduledTasksMonitor(true)
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    confirmCleanupFailedJobs(element) {
      this.$bvModal.msgBoxConfirm('Se eliminarán solo errores de este grupo anteriores a 7 días. No se eliminan jobs pendientes, cron ni otros grupos de errores. ¿Continuar?', {
        title: 'Limpiar grupo de jobs fallidos',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Limpiar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value) {
          this.cleanupFailedJobs(element)
        }
      })
    },
    cleanupFailedJobs(element) {
      this.scheduledTasks.load = true
      var result = serviceAPI.cleanupFailedJobsMonitor({
        queue: element.queue,
        error_message: element.raw_error_message || element.error_message
      })

      result.then((response) => {
        this.$awn.success('Grupo de jobs fallidos limpiado. Registros eliminados: ' + response.data.deleted)
        this.scheduledTasks.loaded = false
        this.loadScheduledTasksMonitor(true)
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    getScheduledTaskErrorVariant(category) {
      switch (category) {
        case 'Configuración':
          return 'warning'
        case 'Base de datos':
          return 'danger'
        case 'Conectividad':
          return 'info'
        default:
          return 'secondary'
      }
    },
    getFailedJobTitle(element) {
      let message = element && element.error_message ? element.error_message : ''
      let className = this.extractLastClassName(message)

      if(className) {
        return className
      }

      if(!message) {
        return 'Job fallido'
      }

      let cleanMessage = message.replace(/^Exception:\s*/i, '').trim()

      if(cleanMessage.length > 55) {
        return cleanMessage.substring(0, 55) + '...'
      }

      return cleanMessage
    },
    extractLastClassName(message) {
      let matches = String(message || '').match(/[A-Za-z0-9_]+(?:\\[A-Za-z0-9_]+)+/g)

      if(!matches || !matches.length) {
        return ''
      }

      let parts = matches[0].split('\\')

      return parts[parts.length - 1] || ''
    },
    formatScheduledTaskDate(date) {
      if(!date) {
        return ''
      }

      return this.moment(date).format('DD/MM/YY HH:mm')
    },
    frequencyLabel(element) {
      var minutes = element.frequency_minutes

      if (!minutes) return 'Alta frecuencia'
      if (minutes == 1) return 'Cada minuto'
      if (minutes < 60) return 'Cada ' + minutes + ' min'
      if (minutes == 60) return 'Cada hora'

      return 'Cada ' + Math.round(minutes / 60) + ' hs'
    },
    formatScheduledTaskDateWithSeconds(date) {
      if(!date) {
        return ''
      }

      return this.moment(date).format('DD/MM/YY HH:mm:ss')
    },
    formatScheduledTaskDateHuman(date) {
      if(!date) {
        return ''
      }

      return this.moment.duration(-this.moment().diff(date)).humanize(true)
    },
    groupScheduledTasksByHour(items) {
      if(!items || !items.length) {
        return []
      }

      let groups = {}

      items.forEach((item) => {
        let key = this.moment(item.date).format('DD/MM/YY HH:00')

        if(!groups[key]) {
          groups[key] = {
            hour: this.moment(item.date).format('HH:00'),
            label: this.moment(item.date).format('DD/MM/YY HH:00'),
            sortDate: this.moment(item.date).valueOf(),
            items: [],
          }
        }

        groups[key].items.push(item)
      })

      return Object.keys(groups)
        .sort((a, b) => groups[a].sortDate - groups[b].sortDate)
        .map((key) => {
          groups[key].items = groups[key].items.sort((a, b) => this.moment(a.date).valueOf() - this.moment(b.date).valueOf())
          return groups[key]
        })
    },

    // TAB SAVE
    saveTabStorage() {
      Storage.setValue('tab_container_aside', this.tabIndex)
    },
    restoreTabStorage() {
      if(this.shortcutsOnly) {
        this.tabIndex = 0
        return
      }

      if(Storage.getValue('tab_container_aside')) {
        this.tabIndex = parseInt(Storage.getValue('tab_container_aside'))
      }

      const lastTabIndex = this.canViewScheduledTasksInfo ? 3 : 2
      if(this.tabIndex < 0 || this.tabIndex > lastTabIndex) {
        this.tabIndex = 0
      }

      if(this.tabIndex == 2) {
        this.filterReport()
      }

      if(this.tabIndex == 3 && this.canViewScheduledTasksInfo) {
        this.loadScheduledTasksMonitor()
      }
    },    
  }
}
</script>
<style>
  .app-aside .b-sidebar {
    background: var(--app-color-surface);
  }
  .app-aside__header {
    align-items: center;
    background: var(--app-color-surface-subtle);
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text);
    font-size: var(--app-text-base);
    font-weight: var(--app-font-semibold);
    min-height: 52px;
    padding: 12px 16px;
  }
  .app-aside__body { background: var(--app-color-surface); }
  .app-aside-tabs > .nav-tabs {
    border-bottom: 1px solid var(--app-color-border);
    gap: 4px;
    padding: 8px 12px 0;
  }
  .app-aside-tabs > .nav-tabs .nav-link {
    align-items: center;
    border: 0;
    border-radius: 7px 7px 0 0;
    color: var(--app-color-text-secondary);
    display: flex;
    justify-content: center;
    min-height: 34px;
    min-width: 42px;
    padding: 7px 10px;
  }
  .app-aside-tabs > .nav-tabs .nav-link:hover { background: var(--app-color-primary-soft); color: var(--app-color-primary); }
  #sidebar-aside .app-aside-tabs .nav-tabs .nav-link.active {
    background: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    box-shadow: 0 2px 5px rgba(11, 31, 59, 0.16) !important;
    color: var(--app-color-on-primary) !important;
  }
  #sidebar-aside .app-aside-tabs .nav-tabs .nav-link.active * { color: var(--app-color-on-primary) !important; }
  .app-aside-tabs > .tab-content { padding: 0; }
  .app-aside-tabs > .tab-content > .tab-pane:not(.app-aside-tab-shortcuts) { padding: 12px; }
  #sidebar-aside .app-aside-tabs .tab-content > .tab-pane:first-child,
  .app-aside-tabs > .tab-content > .app-aside-tab-shortcuts {
    min-height: calc(100vh - 116px);
    padding: 0 !important;
    width: 100% !important;
  }
  .app-aside-tabs > .tab-content > .app-aside-tab-shortcuts .shortcuts-manager--aside {
    min-height: calc(100vh - 116px);
    width: 100%;
  }
  .aside-panel-heading,
  .aside-panel-toolbar {
    align-items: center;
    display: flex;
    gap: 10px;
  }
  .aside-panel-heading { margin-bottom: 10px; }
  .aside-panel-heading > .material-symbols-rounded {
    align-items: center;
    background: var(--app-color-primary-soft);
    border-radius: 7px;
    color: var(--app-color-primary);
    display: inline-flex;
    height: 30px;
    justify-content: center;
    width: 30px;
  }
  .aside-panel-heading strong,
  .aside-panel-toolbar strong { display: block; font-size: var(--app-text-sm); }
  .aside-panel-heading small,
  .aside-panel-toolbar small { color: var(--app-color-text-muted); display: block; font-size: var(--app-text-xs); }
  .aside-panel-toolbar {
    justify-content: space-between;
    margin: 0 0 10px;
    padding: 2px 2px 8px;
  }
  .aside-icon-btn {
    align-items: center;
    border: 1px solid var(--app-color-border) !important;
    border-radius: 6px;
    color: var(--app-color-text-secondary) !important;
    display: inline-flex;
    height: 31px;
    justify-content: center;
    padding: 0 !important;
    width: 31px;
  }
  .aside-icon-btn:hover, .aside-icon-btn:focus { background: var(--app-color-primary-soft) !important; color: var(--app-color-primary) !important; }
  .aside-icon-btn--primary { background: var(--app-color-primary) !important; border-color: var(--app-color-primary) !important; color: var(--app-color-on-primary) !important; }
  .aside-icon-btn--primary:hover, .aside-icon-btn--primary:focus { background: var(--app-color-primary-hover) !important; color: var(--app-color-on-primary) !important; }
  .aside-search-list { border: 0; }
  .aside-search-container { border: 0 !important; padding: 0 0 12px !important; }
  .aside-search-container .input-group { align-items: stretch; }
  .aside-search-container .form-control { border-color: var(--app-color-border); border-radius: 6px 0 0 6px; height: 31px; }
  .aside-search-container .input-group-append { margin-left: 6px; }
  .aside-search-container .input-group-append .aside-icon-btn { border-radius: 6px; }
  .aside-empty-state {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: flex;
    flex-direction: column;
    font-size: var(--app-text-sm);
    gap: 7px;
    padding: 28px 16px;
    text-align: center;
  }
  .aside-empty-state .material-symbols-rounded { color: var(--app-color-text-muted); font-size: 24px; }
  .search-section-title {
    background: transparent !important;
    border: 0 !important;
    color: var(--app-color-text-muted) !important;
    font-size: 11px;
    font-weight: var(--app-font-semibold);
    letter-spacing: .05em;
    padding: 12px 0 5px !important;
    text-transform: uppercase;
  }
  .aside-search-result {
    align-items: center;
    border: 1px solid var(--app-color-border) !important;
    border-radius: 7px !important;
    display: flex;
    gap: 9px;
    margin: 0 0 6px;
    min-height: 48px;
  }
  .aside-search-result .b-avatar { flex: 0 0 auto; height: 28px; width: 28px; }
  .aside-search-result .material-symbols-rounded { display: none; }
  .aside-print-list { border-top: 1px solid var(--app-color-border); }
  .aside-print-item { border-color: var(--app-color-border) !important; padding: 11px 4px; }
  .aside-print-item h5 { color: var(--app-color-text); font-size: var(--app-text-sm); font-weight: var(--app-font-semibold); }
  .aside-print-item small { color: var(--app-color-text-muted); font-size: var(--app-text-xs); }
  #sidebar-aside .aside-print-item:hover,
  #sidebar-aside .aside-print-item:focus,
  #sidebar-aside .aside-print-item.active {
    background: var(--app-color-primary-soft) !important;
    border-color: var(--app-color-primary-200) !important;
    color: var(--app-color-primary-active) !important;
  }
  #sidebar-aside .aside-print-item:hover h5,
  #sidebar-aside .aside-print-item:focus h5,
  #sidebar-aside .aside-print-item.active h5 { color: var(--app-color-primary-active) !important; }
  #sidebar-aside .aside-print-item:hover small,
  #sidebar-aside .aside-print-item:focus small,
  #sidebar-aside .aside-print-item.active small { color: var(--app-color-text-secondary) !important; }
  #sidebar-aside .aside-print-item:hover .badge,
  #sidebar-aside .aside-print-item:focus .badge,
  #sidebar-aside .aside-print-item.active .badge {
    background: var(--app-color-surface) !important;
    color: var(--app-color-primary-active) !important;
  }
  .title-select {
    padding: 8px;
  }
  .access-direct-select {
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;    
    padding-right: 10px;
    border-bottom-style: solid !important;
    border-bottom-width: 1px !important;
    border-bottom-color: var(--app-color-border) !important;
  }
  .b-sidebar .list-group-item.aside-search-container:hover,
  .b-sidebar .list-group-item.aside-search-container:focus,
  .b-sidebar .list-group-item.aside-search-container.active {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border) !important;
    color: var(--app-color-text) !important;
  }
  .b-sidebar .list-group-item.aside-search-container:hover .aside-panel-heading strong,
  .b-sidebar .list-group-item.aside-search-container:focus .aside-panel-heading strong,
  .b-sidebar .list-group-item.aside-search-container.active .aside-panel-heading strong {
    color: var(--app-color-text) !important;
  }
  .b-sidebar .list-group-item.aside-search-container:hover .aside-panel-heading small,
  .b-sidebar .list-group-item.aside-search-container:focus .aside-panel-heading small,
  .b-sidebar .list-group-item.aside-search-container.active .aside-panel-heading small {
    color: var(--app-color-text-muted) !important;
  }
  .b-sidebar .list-group-item.search-section-title:hover,
  .b-sidebar .list-group-item.search-section-title:focus,
  .b-sidebar .list-group-item.search-section-title.active {
    background-color: var(--app-color-surface-subtle) !important;
    border-color: var(--app-color-border) !important;
    color: var(--app-color-text-muted) !important;
  }
  .b-sidebar .access-direct-select:hover,
  .b-sidebar .access-direct-select:focus,
  .b-sidebar .access-direct-select.active {
    background-color: var(--app-color-primary-soft) !important;
    border-color: var(--app-color-primary-200) !important;
    color: var(--app-color-primary-active) !important;
  }
  .b-sidebar .access-direct-select:hover *,
  .b-sidebar .access-direct-select:focus *,
  .b-sidebar .access-direct-select.active * {
    color: inherit !important;
  }
  .scheduled-section-title {
    border-left: 4px solid var(--app-color-border-strong);
    padding-left: 8px;
  }
  .scheduled-section-title-warning {
    border-left-color: var(--app-color-warning);
  }
  .scheduled-section-title-danger {
    border-left-color: var(--app-color-danger);
  }
  .scheduled-section-title-success {
    border-left-color: var(--app-color-success);
  }
  .scheduled-section-title-info {
    border-left-color: var(--app-color-info);
  }
  .scheduled-accordion .card-header {
    border-left-width: 4px;
    border-left-style: solid;
  }
  .scheduled-accordion .btn {
    font-weight: 600;
  }
  .scheduled-accordion .list-group-item:hover,
  .scheduled-accordion .list-group-item:focus {
    background-color: var(--app-color-surface-subtle) !important;
    border-color: var(--app-color-border) !important;
    color: inherit !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover,
  .b-sidebar .scheduled-accordion .list-group-item:focus,
  .b-sidebar .scheduled-accordion .list-group-item.active {
    background-color: var(--app-color-surface-subtle) !important;
    border-color: var(--app-color-border) !important;
    color: var(--app-color-text) !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover *,
  .b-sidebar .scheduled-accordion .list-group-item:focus *,
  .b-sidebar .scheduled-accordion .list-group-item.active * {
    color: inherit !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover .scheduled-task-stats-success,
  .b-sidebar .scheduled-accordion .list-group-item:focus .scheduled-task-stats-success,
  .b-sidebar .scheduled-accordion .list-group-item.active .scheduled-task-stats-success {
    background-color: var(--app-color-success-soft) !important;
    color: var(--app-color-success-hover) !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover .scheduled-task-stats-danger,
  .b-sidebar .scheduled-accordion .list-group-item:focus .scheduled-task-stats-danger,
  .b-sidebar .scheduled-accordion .list-group-item.active .scheduled-task-stats-danger {
    background-color: var(--app-color-danger-soft) !important;
    color: var(--app-color-danger-hover) !important;
  }
  .scheduled-accordion .list-group-item:hover .scheduled-task-title,
  .scheduled-accordion .list-group-item:focus .scheduled-task-title {
    color: var(--app-color-text) !important;
  }
  .scheduled-accordion .list-group-item:hover .scheduled-task-meta,
  .scheduled-accordion .list-group-item:focus .scheduled-task-meta {
    color: var(--app-color-text-secondary) !important;
  }
  .scheduled-accordion .card-body:hover,
  .scheduled-accordion .scheduled-task-item:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: inherit !important;
  }
  .scheduled-task-item {
    min-width: 0;
    width: 100%;
  }
  .scheduled-task-title {
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 3px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-task-meta {
    color: var(--app-color-text-muted);
    font-size: 12px;
    line-height: 1.25;
    margin-bottom: 8px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-upcoming-group {
    border: 1px solid var(--app-color-info-border);
    border-radius: 4px;
    box-shadow: none;
  }
  .scheduled-upcoming-group-header {
    background: var(--app-color-info-soft);
    border-bottom: 1px solid var(--app-color-info-border);
    padding: 0.5rem 0.5rem !important;
  }
  .scheduled-upcoming-button {
    align-items: center;
    color: var(--app-color-primary);
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 6px 8px;
  }
  .scheduled-upcoming-button:hover,
  .scheduled-upcoming-button:focus {
    background: var(--app-color-primary-soft-hover);
    color: var(--app-color-primary-active);
    text-decoration: none;
  }
  .scheduled-upcoming-button .badge {
    flex: 0 0 auto;
    line-height: 1.2;
    padding: 5px 7px;
  }
  .scheduled-upcoming-item {
    padding-top: 14px;
    padding-bottom: 14px;
    min-height: 90px;
  }
  .scheduled-upcoming-title {
    padding-right: 8px;
  }
  .scheduled-upcoming-time {
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .scheduled-task-stats {
    align-items: center;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    font-weight: 700;
    gap: 4px;
    justify-content: space-between;
    padding: 6px 8px;
    width: 100%;
  }
  .scheduled-task-stats span {
    flex: 1 1 58px;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .scheduled-task-stats-success {
    background: var(--app-color-success-soft);
    color: var(--app-color-success-hover);
  }
  .scheduled-task-stats-danger {
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger-hover);
  }
  .scheduled-task-stats-info {
    background: var(--app-color-info-soft);
    color: var(--app-color-primary);
  }
  .scheduled-subsection-title {
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text-secondary);
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 8px;
    padding-bottom: 4px;
    text-transform: uppercase;
  }
  .scheduled-job-attempts {
    color: var(--app-color-warning-hover);
    font-size: 12px;
    font-weight: 600;
    margin-top: 6px;
  }
  .scheduled-module-group {
    margin-bottom: 12px;
  }
  .scheduled-module-header {
    background: var(--app-color-success-soft);
    border-left: 5px solid var(--app-color-success);
  }
  .scheduled-module-button {
    align-items: center;
    color: var(--app-color-success-hover);
    display: flex;
    font-weight: 700;
    justify-content: space-between;
  }
  .scheduled-module-button:hover,
  .scheduled-module-button:focus {
    background-color: var(--app-color-success-border);
    color: var(--app-color-success-hover);
    text-decoration: none;
  }
  .scheduled-module-group .card {
    border: 1px solid var(--app-color-success-border);
    border-radius: 4px;
    box-shadow: none;
  }
  .scheduled-executed-item,
  .scheduled-executed-item:hover,
  .scheduled-executed-item:focus {
    background-color: var(--app-color-surface) !important;
    color: var(--app-color-text) !important;
  }
  .scheduled-executed-item:hover .scheduled-task-item,
  .scheduled-executed-item:focus .scheduled-task-item {
    background-color: var(--app-color-success-soft) !important;
    border-radius: 4px;
    color: var(--app-color-text) !important;
  }
  .scheduled-executed-item:hover .scheduled-task-title,
  .scheduled-executed-item:focus .scheduled-task-title {
    color: var(--app-color-success-hover) !important;
  }
  .scheduled-executed-item:hover .scheduled-task-meta,
  .scheduled-executed-item:focus .scheduled-task-meta {
    color: var(--app-color-text-secondary) !important;
  }
  .scheduled-warning-summary {
    align-items: center;
    background: var(--app-color-warning-soft);
    border: 1px solid var(--app-color-warning-border);
    border-left: 4px solid var(--app-color-warning);
    border-radius: 4px;
    color: var(--app-color-warning-hover);
    display: flex;
    gap: 10px;
    padding: 10px;
  }
  .scheduled-warning-summary-count {
    align-items: center;
    background: var(--app-color-warning);
    border-radius: 4px;
    color: var(--app-color-on-primary);
    display: flex;
    flex: 0 0 38px;
    font-size: 18px;
    font-weight: 700;
    height: 38px;
    justify-content: center;
  }
  .scheduled-maintenance-actions {
    border-top: 1px solid var(--app-color-border);
    margin-top: 12px;
    padding-top: 10px;
    text-align: right;
  }
  .scheduled-group-actions {
    margin-top: 8px;
    text-align: right;
  }
  .scheduled-accordion-label {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-accordion-main {
    align-items: flex-start;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    width: 100%;
  }
  .scheduled-accordion-title {
    display: block;
    line-height: 1.2;
  }
  .scheduled-accordion-subtitle {
    color: var(--app-color-danger-hover);
    display: block;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 3px;
  }
  .scheduled-accordion-badge {
    flex: 0 1 96px;
    line-height: 1.15;
    max-width: 96px;
    padding-left: 4px;
    padding-right: 4px;
    text-align: center;
    white-space: normal;
  }
  .scheduled-accordion-totals {
    align-items: center;
    border-radius: 4px;
    display: flex;
    font-size: 12px;
    font-weight: 700;
    gap: 6px;
    justify-content: space-between;
    margin-top: 8px;
    padding: 5px 8px;
    width: 100%;
  }
  .scheduled-accordion-totals span {
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
  }
  .scheduled-accordion-totals-danger {
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger-hover);
  }
  .scheduled-accordion-summary {
    color: var(--app-color-danger-hover);
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 6px;
    text-align: right;
    width: 100%;
  }
  .scheduled-accordion-icon {
    color: var(--app-color-danger);
    flex: 0 0 12px;
    font-size: 11px;
    margin-left: 2px;
  }
  .scheduled-error-group {
    border: 1px solid var(--app-color-danger-border);
    border-radius: 4px;
    box-shadow: none;
    max-width: 100%;
  }
  .scheduled-error-header {
    background: var(--app-color-danger-soft);
    border-left: 5px solid var(--app-color-danger);
  }
  .scheduled-error-button {
    align-items: stretch;
    color: var(--app-color-danger);
    display: flex;
    flex-direction: column;
    font-weight: 700;
    gap: 4px;
    justify-content: flex-start;
    min-width: 0;
  }
  .scheduled-error-button:hover,
  .scheduled-error-button:focus {
    background-color: var(--app-color-danger-border);
    color: var(--app-color-danger-hover);
    text-decoration: none;
  }
  .scheduled-sales-sync-staff-group {
    border: 1px solid var(--app-color-danger-border);
    border-radius: 4px;
    box-shadow: none;
    max-width: 100%;
  }
  .scheduled-sales-sync-staff-header {
    background: var(--app-color-danger-soft);
    border-left: 5px solid var(--app-color-danger);
  }
  .scheduled-sales-sync-staff-button {
    align-items: stretch;
    color: var(--app-color-danger);
    display: flex;
    flex-direction: column;
    font-weight: 700;
    gap: 4px;
    justify-content: flex-start;
    min-width: 0;
  }
  .scheduled-sales-sync-staff-button:hover,
  .scheduled-sales-sync-staff-button:focus {
    background-color: var(--app-color-danger-border);
    color: var(--app-color-danger-hover);
    text-decoration: none;
  }
  .scheduled-sales-sync-error-item {
    background: var(--app-color-surface) !important;
    border-color: var(--app-color-danger-border) !important;
    color: var(--app-color-text);
    padding: 10px;
  }
  .scheduled-sales-sync-error-item .scheduled-task-title {
    color: var(--app-color-text);
    font-size: 13px;
  }
  .scheduled-sales-sync-error-item .scheduled-task-meta {
    color: var(--app-color-text-secondary);
  }
  .scheduled-sales-sync-error-item .scheduled-task-stats {
    align-items: stretch;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
  }
  .scheduled-sales-sync-error-item .scheduled-task-stats span {
    background: var(--app-color-surface);
    border-radius: 3px;
    line-height: 1.2;
    padding: 2px 3px;
    text-align: center;
  }
</style>
